import { generateHeadTitle } from 'shared/components/common'
import PrivacyPolicy from 'src/modules/privacyPolicy'

const PrivacyPolicyScreen = () => {
  return (
    <>
      {generateHeadTitle('Privacy Policy | VTR Minting Platform')}

      <PrivacyPolicy />
    </>
  )
}

export default PrivacyPolicyScreen
